import React from 'react';
import { CarIcon } from 'lucide-react';
import { vehicleSizes } from '../../data/schedule';
import { Draft } from '../../types/booking';
type Props = {
  draft: Draft;
  onChange: (patch: Partial<Draft>) => void;
};
export function StepVehicle({
  draft,
  onChange
}: Props) {
  return <div data-id="element-473" data-mp="3ei1zsaizlvx8">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-474" data-mp="3eh9362dqsmst">
        {vehicleSizes.map(size => {
        const selected = draft.vehicleSizeId === size.id;
        return <button key={size.id} type="button" aria-pressed={selected} onClick={() => onChange({
          vehicleSizeId: size.id
        })} className={`flex items-center gap-4 rounded-2xl border p-5 text-left transition-colors duration-200 ease-smooth ${selected ? 'border-ember bg-panel' : 'border-edge bg-carbon hover:border-ember/40'}`} data-id="element-475" data-mp="3nign1ffihl3d">
              <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full border ${selected ? 'border-ember bg-ember text-void' : 'border-edge text-dim'}`} data-id="element-476" data-mp="b2d1pr94jp91">
                <CarIcon className="h-5 w-5" aria-hidden="true" data-id="element-477" data-mp="2la1o67t6a0kl" />
              </span>
              <span className="flex-1" data-id="element-478" data-mp="2q9edcz7injqc">
                <span className="block font-display text-lg font-extrabold tracking-tight text-chalk" data-id="element-479" data-mp="2v6xss2fya2jv">
                  {size.label}
                </span>
                <span className="mt-0.5 block text-xs text-dim" data-id="element-480" data-mp="303eopite5l7i">{size.note}</span>
              </span>
              <span className="text-sm font-semibold text-ember" data-id="element-481" data-mp="34500f0u6vtg4">
                {size.surchargePct === 0 ? 'Basisprijs' : `+${size.surchargePct}%`}
              </span>
            </button>;
      })}
      </div>

      <p className="mt-6 rounded-xl border border-edge bg-carbon px-5 py-4 text-sm leading-relaxed text-dim" data-id="element-482" data-mp="3iw8tjjxavwy0">
        Grotere voertuigen kosten meer tijd en materiaal. De toeslag is verwerkt in het totaal dat u hiernaast
        ziet — geen verrassingen bij het afrekenen.
      </p>
    </div>;
}